import richText from "utilities/richText"
import Checkbox from "/public/assets/checkbox.svg"

export default function ListItem({ item: { heading, content } }) {
  return (
    <li>
      <h3 className="tracking-wider text-green-kelly uppercase mb-1">
        <Checkbox className="inline-block mr-2 align-middle size-6 2xl:size-10" />
        <span className="inline-block align-middle">{heading}</span>
      </h3>
      <div className="prose text-white">{richText(content)}</div>
    </li>
  )
}
